import QrCreator from "qr-creator";
import React, { useCallback, useEffect, useRef } from "react";

// Gradient config
// {
//   type: 'radial-gradient', // or 'linear-gradient'
//   position: [ ... ],
//   colorStops: [
//       [ offset0, color0 ],
//       [ offset1, color1 ],
//       ...
//   ]
// }

interface Props {
  background?: string | null;
  className?: string;
  ecLevel?: QrCreator.ErrorCorrectionLevel;
  fill: string | QrCreator.LinearGradient | QrCreator.RadialGradient;
  left?: number;
  maxVersion?: number;
  minVersion?: number;
  quiet?: number;
  radius?: number;
  size: number;
  text: string;
  top?: number;
  backgroundImage?: string;
  onChange?: (data: string) => void;
}

const QrCode: React.FC<Props> = ({
  background,
  className,
  ecLevel,
  fill,
  maxVersion,
  minVersion,
  quiet,
  radius,
  size,
  text,
  backgroundImage,
  onChange
}) => {
  const containerRef = useRef<HTMLCanvasElement | null>(null);

  const renderQrCode = useCallback(() => {
    // QR Element
    let canvas = containerRef.current;

    if (canvas) {
      let config = { text, fill, size } as QrCreator.Config;

      if (radius) {
        config.radius = radius;
      }

      if (ecLevel) {
        config.ecLevel = ecLevel;
      }

      if (background) {
        config.background = background;
      }

      if (quiet) {
        config.quiet = quiet;
      }

      if (minVersion) {
        config.minVersion = minVersion;
      }

      if (maxVersion) {
        config.maxVersion = maxVersion;
      }

      QrCreator.render(config, canvas);

      if (backgroundImage) {
        var logo = new Image();
        logo.width = size;
        logo.height = size;
        logo.onload = () => {
          let ctx = canvas?.getContext("2d");
          if (ctx) {
            ctx.globalCompositeOperation = "overlay";
            ctx.globalAlpha = 0.75;
            ctx.drawImage(logo, 0, 0, size, size);

            if (onChange) {
              let data = canvas?.toDataURL("image/png") || "";
              onChange(data);
            }
          }
        };
        logo.src = backgroundImage;
      }
    }
  }, [
    text,
    fill,
    size,
    radius,
    ecLevel,
    background,
    quiet,
    minVersion,
    maxVersion,
    backgroundImage,
    onChange
  ]);

  useEffect(() => {
    if (containerRef.current) {
      renderQrCode();
    }
  }, [backgroundImage, onChange, renderQrCode, size]);

  return <canvas ref={containerRef} className={className} />;
};

export default QrCode;
